import { render, staticRenderFns } from "./IOSSNumbersFilter.vue?vue&type=template&id=2e49fd38&scoped=true"
import script from "./IOSSNumbersFilter.vue?vue&type=script&lang=js"
export * from "./IOSSNumbersFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e49fd38",
  null
  
)

export default component.exports